<template>
    <div class="ah-page project-edit-page">
        <div class="page-header bottom-margin" id="project-edit-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增專案</h1>
                        <h1 v-if="form.sno">編輯專案</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <el-form :model="form" ref="mainForm" :rules="rules" :label-position="isMobile() ? 'top' : 'right'" label-width="220px" v-loading="isLoading">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">專案內容</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="pjcaT_SNO" label="專案類型">
                            <el-select v-model="form.pjcaT_SNO" no-data-text="無資料" placeholder="請選擇" filterable>
                                <el-option :label="item.pjcaT_NAM" :value="item.sno" v-for="item in projectTypeOptions" :key="item.sno"></el-option>
                            </el-select>
                            <el-button style="margin-left: 5px" icon="el-icon-plus" v-if="isAuth('C05') && !isQR()" @click="editProjectTypeDialog.visible = true"></el-button>
                            <ah-tip v-if="!isAuth('C05') || isQR()">如欲新增類型，請聯絡有該權限的使用者。</ah-tip>
                        </el-form-item>
                        <el-form-item prop="customnumber" label="自訂專案編號">
                            <el-input v-model="form.customnumber" :maxlength="20" :show-word-limit="true" style="width: 90%; max-width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item prop="nam" label="專案名稱">
                            <el-input
                                v-model="form.nam"
                                type="textarea"
                                :maxlength="200"
                                :show-word-limit="true"
                                class="ah-el-input-textarea"
                                autosize
                                resize="none"
                                @keydown.enter.native="onNamInputKeydown($event)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.sno" label="專案狀態">
                            <el-radio-group v-model="form.stG_STS" @change="onChangeProjectStatus">
                                <el-radio :label="1">結案</el-radio>
                                <el-radio :label="0">進行中</el-radio>
                            </el-radio-group>
                            <div v-if="form.stG_STS === 1" style="margin-top: 10px">
                                <el-alert :closable="false" type="warning" style="display: inline-block; width: unset; line-height: 120%"> 結案後無法再對此專案申請「專案請款單」。 </el-alert>
                            </div>
                        </el-form-item>
                        <el-form-item prop="stF_SNO" label="專案經理(PM)" v-if="isAuth('C04')">
                            <el-select v-model="form.stF_SNO" prop="stF_SNO" no-data-text="無資料" placeholder="請選擇" @change="onPmChange" filterable>
                                <el-option v-for="item in pmList" :label="item.active ? item.nam : `${item.nam}（已停用）`" :value="item.sno" :key="item.sno"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="projectAuditor" label="專案經辦人">
                            <template v-slot:label>
                                <div>
                                    <ahRichPopInfo title="專案經辦人" content="可以審核此專案請款單的專員。（審核流程需設定「專案經辦人」）" :width="300">
                                        <span class="tip" :style="isProjectAuditorAuditNeed ? '' : 'opacity: 0.4'">專案經辦人</span>
                                    </ahRichPopInfo>
                                    <ah-tip icon="el-icon-warning-outline" codlor="#ffa230" v-if="!isProjectAuditorAuditNeed">當前專案審核流程未啟用專案經辦人，此項目無作用。</ah-tip>
                                </div>
                            </template>
                            <el-select v-model="form.projectAuditor" prop="projectAuditor" no-data-text="無資料" placeholder="請選擇" @change="onPaChange" filterable>
                                <el-option label="無" :value="null" :key="0"></el-option>
                                <el-option v-for="item in paList" :label="item.active ? item.nam : `${item.nam}（已停用）`" :value="item.sno" :key="item.sno">
                                    <div>
                                        <span class="project-edit-page-project-auditor-option-view-hint">
                                            <i v-if="item.pm || item.projectAllManager || item.projectSearcher" class="el-icon-view"></i>
                                        </span>
                                        <span>{{ item.nam }}</span>
                                        <span v-if="!item.active">（已停用）</span>
                                    </div>
                                </el-option>
                            </el-select>
                            <div v-if="false" class="project-auditor-settings">
                                <div>
                                    <div style="display: inline-block; width: 300px">
                                        <span>可以從「請款單」檢視此專案細節 </span>
                                        <ahRichPopInfo
                                            :img="require('@/assets/img/rich-pop-info/project-edit-detail.png')"
                                            title="請款單：專案細節"
                                            content="顯示專案所有內容，包含：專案資訊、分期款項、支出明細、成案依據...等。"
                                            :width="400"
                                        >
                                            <span class="tip"><i class="el-icon-warning-outline"></i></span>
                                        </ahRichPopInfo>
                                    </div>
                                    <el-radio-group v-model="form.isProjectDetailsVisible">
                                        <el-radio :label="true">是</el-radio>
                                        <el-radio :label="false">否</el-radio>
                                    </el-radio-group>
                                </div>
                                <div>
                                    <div style="display: inline-block; width: 300px">
                                        <span>可以從「請款單」看見此專案的支出預算圖表 </span>
                                        <ahRichPopInfo :img="require('@/assets/img/rich-pop-info/project-edit-budget-graph.png')" title="請款單：專案支出預算圖表" :width="400">
                                            <span class="tip"><i class="el-icon-warning-outline"></i></span>
                                        </ahRichPopInfo>
                                    </div>
                                    <el-radio-group v-model="form.isProjectBudgetVisible">
                                        <el-radio :label="true">是</el-radio>
                                        <el-radio :label="false">否</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="vdR_SNO" label="客戶">
                            <el-select
                                v-model="form.vdR_SNO"
                                filterable
                                style="width: 90%; max-width: 450px; margin-right: 8px"
                                remote
                                clearable
                                :remote-method="vendorRemoteMethod"
                                :placeholder="companyInfo.displayClient ? '選擇客戶' : '請輸入客戶關鍵字（至少兩個字）'"
                                :no-data-text="companyInfo.displayClient ? '無資料' : '無匹配資料'"
                                @keydown.native.capture.enter="preventIMESelect"
                            >
                                <el-option v-for="item in vendorList" :key="item.sno" :label="item.fnam" :value="item.sno"></el-option>
                            </el-select>
                            <el-popconfirm
                                v-if="isAuth('C02') && !isQR()"
                                title="將前往新增，新增後會自動返回。"
                                confirm-button-text="前往新增"
                                cancel-button-text="取消"
                                icon="el-icon-warning"
                                @confirm="onAddVendoerBtnClick"
                            >
                                <el-button icon="el-icon-plus" slot="reference" :disabled="!isAuth('C02')"></el-button>
                            </el-popconfirm>
                            <el-tooltip v-if="!isAuth('C02') || isQR()" class="item" effect="light" content="您沒有編輯客戶權限" placement="top">
                                <span>
                                    <el-button icon="el-icon-plus" :disabled="true"></el-button>
                                </span>
                            </el-tooltip>
                        </el-form-item>
                        <div>
                            <el-form-item prop="sdt" label="專案開始日" style="display: inline-block">
                                <el-date-picker v-model="form.sdt" type="date" placeholder="選擇日期" value-format="timestamp"> </el-date-picker>
                            </el-form-item>
                            <el-form-item prop="edt" label="預計結案日" style="display: inline-block">
                                <el-date-picker v-model="form.edt" type="date" placeholder="選擇日期" value-format="timestamp"> </el-date-picker>
                            </el-form-item>
                        </div>
                        <el-form-item prop="amt">
                            <template slot="label">
                                <span>專案總價(含稅)</span>
                            </template>
                            <el-tooltip :manual="!isCnyDisabled" content="此專案已有分期申請發票、或已有請款，無法變更幣別。" effect="light" placement="top">
                                <el-select
                                    v-model="form.cny"
                                    prop="cny"
                                    style="width: 100px; margin-right: 6px"
                                    no-data-text="無資料"
                                    placeholder="幣別"
                                    :disabled="isCnyDisabled"
                                    @change="onCnyChange"
                                >
                                    <el-option :label="item.cnynam" :value="item.cny" v-for="item in currencyList" :key="item.sno"></el-option>
                                </el-select>
                            </el-tooltip>
                            <MoneyInput ref="amtInput" v-model="form.amt" :precision="form.cny == 'TWD' ? 0 : 4" style="width: 240px" @change="handleAmtChanged" />
                            <span v-if="installmentsDiscountTotal > 0" style="color: #888; margin-left: 5px"> 已折讓金額：{{ installmentsDiscountTotal }}</span>
                            <div v-if="form.cny != 'TWD'" class="suffix-box">
                                <span>約當台幣：</span>
                                <Money :v="amtInTwd" /> 元
                            </div>
                        </el-form-item>
                        <el-form-item prop="amT_PREOUT" label="專案支出預算(台幣)">
                            <el-tooltip content="支出皆以台幣計算。" effect="light" placement="top">
                                <el-select value="TWD" prop="cny" style="width: 100px; margin-right: 6px" no-data-text="無資料" placeholder="幣別" :disabled="true">
                                    <el-option :label="item.cnynam" :value="item.cny" v-for="item in currencyList" :key="item.sno"></el-option>
                                </el-select>
                            </el-tooltip>
                            <MoneyInput v-model="form.amT_PREOUT" style="width: 240px" />
                            <span class="suffix-box">毛利率：{{ grossMargin }}</span>
                        </el-form-item>
                        <el-form-item prop="note" label="專案備註" style="margin-top: 60px">
                            <el-input type="textarea" v-model="form.note" :autosize="{ minRows: 4, maxRows: 15 }" :maxlength="200" :show-word-limit="true"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">分期款項 <ahTip>開發票時依分期來開立</ahTip></div>
                    </div>
                    <div class="panel-body">
                        <div class="installments-table-area">
                            <el-table
                                :data="
                                    form.installments.filter((item) => {
                                        return item.Delete != true && item.status != 5;
                                    })
                                "
                                class="installment-table"
                                empty-text="無分期"
                                row-key="key"
                            >
                                <el-table-column prop="stG_NO" label="期別" width="135">
                                    <template slot-scope="scope">
                                        <div class="inst-no-set">
                                            <span>第</span>
                                            <el-input class="installment-no" v-model="scope.row.stG_NO" style="width: 65px" :disabled="form.sno && scope.row.invoiceIOO != null"></el-input>
                                            <span>期</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="invoiceIOO" label="發票單號" min-width="300">
                                    <template slot-scope="scope">
                                        <div class="inst-invoice-set">
                                            <InvoiceStatusLabel v-if="scope.row.invoiceNo" :status-num="scope.row.status" size="small" />
                                            <el-button type="text" @click="handleInvoiceIOOClick(scope.row.invoiceNo)">{{ scope.row.invoiceIOO }}</el-button>
                                            <el-tooltip content="該分期不列入專案總價計算" effect="light" placement="top">
                                                <div v-if="scope.row.foO_DIS_CNL" class="invoiceVoidLabel">發票已作廢</div>
                                            </el-tooltip>
                                            <div v-if="scope.row.foO_DIS_AMT" style="color: red">
                                                <div class="invoiceVoidLabel">已折讓：<money :v="scope.row.foO_DIS_AMT" /></div>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="amt" label="含稅金額" width="250">
                                    <template slot-scope="scope">
                                        <template v-if="isInstallmentEditDisabled(scope.row)">
                                            <el-tooltip class="item" effect="light" :content="getInsAmtInputTooltipText(scope.row)" placement="top">
                                                <MoneyInput
                                                    v-model="scope.row.amt"
                                                    :precision="form.cny == 'TWD' ? 0 : 4"
                                                    :disabled="true"
                                                    :class="{ voidInsAmtInput: scope.row.foO_DIS_CNL }"
                                                    :suffix="form.cny"
                                                />
                                            </el-tooltip>
                                        </template>
                                        <template v-else>
                                            <MoneyInput v-model="scope.row.amt" :precision="form.cny == 'TWD' ? 0 : 4" :suffix="form.cny" />
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column label="百分比" width="100" align="center">
                                    <template slot-scope="scope" v-if="!scope.row.foO_DIS_CNL">
                                        {{ getInstallmentItemPercent(scope.row.amt) }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="action" label="刪除" width="80" align="center">
                                    <template slot-scope="scope">
                                        <el-button
                                            size="small"
                                            @click="removeInstallment(scope.row)"
                                            v-if="scope.$index !== 0 && scope.row.invoiceIOO == null && !isQR()"
                                            icon="el-icon-delete"
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-row>
                                <el-col :md="12">
                                    <div style="padding: 20px 0">
                                        <el-button v-if="!isQR()" size="small" @click="handleAddInstallmentBtnClick" type="primary" icon="el-icon-plus">增加分期</el-button>
                                        <el-button v-if="isShowAutoInstAmtButton && !isQR()" size="small" @click="averageInstallmentsAmt" icon="el-icon-magic-stick">自動分配金額</el-button>
                                        <el-button v-if="deleteInstallmentsCount > 0 && !isQR()" size="small" @click="handleRestoreInstallmentBtnClick" icon="el-icon-refresh-left">復原刪除</el-button>
                                    </div>
                                </el-col>
                                <el-col :md="12">
                                    <div class="total-area">
                                        <table class="total-table">
                                            <tr>
                                                <th>分期總計（含稅）</th>
                                                <td>
                                                    <Money :v="installmentsTotal" :precision="form.cny == 'TWD' ? 0 : 4" />
                                                    <span class="cny">{{ form.cny }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>專案總價（含稅）</th>
                                                <td>
                                                    <Money :v="form.amt" :precision="form.cny == 'TWD' ? 0 : 4" />
                                                    <span class="cny">{{ form.cny }}</span>
                                                </td>
                                            </tr>
                                        </table>
                                        <div v-if="!validateInstallments" class="installmentsTotalInvalidAlert"><i class="el-icon-warning"></i>「分期總計」需與「專案總價」相符</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title"><span style="background-color: #ffe36c; color: #fff; font-size: 9pt; font-weight: bold; padding: 2px 4px; border-radius: 4px; margin-right: 5px">New</span>專案成員</div>
                    </div>
                    <div class="panel-body">
                        <div style="padding-left: 50px">
                            <div v-if="isPayed('C07')" style="display: flex; justify-content: end; gap: 10px; padding: 0 0 0px; margin: 0px 0 30px 0">
                                <el-select v-model="staffsToAdd" placeholder="請選擇帳號" no-data-text="無資料" no-match-text="無相關資料" :filterable="true" multiple style="width: 50%">
                                    <el-option v-for="item in filteredStaffOptions" :key="item.sno" :label="item.nam" :value="item.sno">
                                        <span class="name" style="float: left">{{ item.nam }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.eml }}</span>
                                    </el-option>
                                </el-select>
                                <el-button v-if="!isQR()" type="primary" icon="el-icon-plus" @click="onAddMemberBtnClick" size="small">新增成員</el-button>
                            </div>
                            <div v-else style="display: flex; justify-content: end; gap: 10px; padding: 0 0 0px; margin: 0px 0 30px 0">
                                <ahRichPopInfo title="加購功能：自訂專案成員" content="此功能可讓您自由指定專案參與成員，並進行細部的權限控管。如需啟用此功能，請洽 Sokuji 業務團隊！" :width="300">
                                    <div style="display: inline-block; cursor: pointer;">
                                        <el-button type="primary" icon="el-icon-plus" disabled size="small" style="pointer-events: none;">新增成員 (未購買)</el-button>
                                    </div>
                                </ahRichPopInfo>
                            </div>
                            <el-table :data="combinedProjectMembers" style="width: 100%; margin-bottom: 20px" empty-text="尚無成員">
                                <el-table-column type="index" label="#" width="50"></el-table-column>
                                <el-table-column prop="employeeName" label="成員">
                                    <template slot-scope="scope">
                                        <div class="staff-member-name" :class="scope.row.role">{{ scope.row.employeeName }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="auth-payment" label="專案請款單" width="200" align="center">
                                    <template slot-scope="scope">
                                        <div style="display: flex; gap: 20px; align-items: center; justify-content: center">
                                            <div class="auth-check-item">
                                                <el-tooltip :disabled="!isNoPermission(scope.row, 'hasA01')" content="該帳號無此權限" placement="top" effect="light">
                                                    <span style="display: inline-block;">
                                                        <el-checkbox v-model="scope.row.paymentRequest" :disabled="(scope.row.role !== 'OTHER' && !scope.row.hasA01) || getEmployeeSettingEnable(scope.row.role)"> 申請 </el-checkbox>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                            <div class="auth-check-item">
                                                <el-tooltip :disabled="!isNoPermission(scope.row, 'hasA01')" content="該帳號無此權限" placement="top" effect="light">
                                                    <span style="display: inline-block;">
                                                        <el-checkbox v-model="scope.row.paymentBudgetChart" :disabled="(scope.row.role !== 'OTHER' && !scope.row.hasA01) || getEmployeeSettingEnable(scope.row.role)">
                                                            <span>顯示預算</span>
                                                            <ahRichPopInfo :img="require('@/assets/img/rich-pop-info/project-edit-budget-graph.png')" title="請款單：專案支出預算圖表" :width="400">
                                                                <i class="el-icon-warning-outline tip" style="font-size: 9pt; margin-left: 3px"></i>
                                                            </ahRichPopInfo>
                                                        </el-checkbox>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="auth-invoice" label="發票" width="130" align="center">
                                    <template slot-scope="scope">
                                        <el-tooltip :disabled="!isNoPermission(scope.row, 'hasB01')" content="該帳號無此權限" placement="top" effect="light">
                                            <span style="display: inline-block;">
                                                <el-checkbox v-model="scope.row.invoice" :disabled="(scope.row.role !== 'OTHER' && !scope.row.hasB01) || getEmployeeSettingEnable(scope.row.role)">申請發票</el-checkbox>
                                            </span>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="auth-service-fee" label="勞報單" width="130" align="center">
                                    <template slot-scope="scope">
                                        <el-tooltip :disabled="!isNoPermission(scope.row, 'hasH01')" content="該帳號無此權限" placement="top" effect="light">
                                            <span style="display: inline-block;">
                                                <el-checkbox v-model="scope.row.laborForm" :disabled="(scope.row.role !== 'OTHER' && !scope.row.hasH01) || getEmployeeSettingEnable(scope.row.role)">申請勞報單</el-checkbox>
                                            </span>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="auth-detail" label="專案內容" width="200" align="center">
                                    <template slot-scope="scope">
                                        <div style="display: flex; gap: 20px; align-items: center; justify-content: center">
                                            <div class="auth-check-item">
                                                <el-checkbox v-if="scope.row.role !== 'OTHER'" v-model="scope.row.viewProject" :disabled="getEmployeeSettingEnable(scope.row.role)"> 檢視 </el-checkbox>
                                            </div>
                                            <div class="auth-check-item">
                                                <el-checkbox v-if="scope.row.role !== 'OTHER'" v-model="scope.row.uploadDocument" :disabled="getEmployeeSettingEnable(scope.row.role)">
                                                    上傳文件
                                                </el-checkbox>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="action" label="" width="70">
                                    <template slot-scope="scope">
                                        <el-button
                                            v-if="scope.row.role === 'STAFF'"
                                            icon="el-icon-delete"
                                            size="mini"
                                            :disabled="!isPayed('C07')"
                                            @click="removeProjectMemberStaff(scope.row.employeeSno)"
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">成案依據</div>
                    </div>
                    <div class="panel-body">
                        <ProjectDetailContractTab v-model="form.contractFiles" :project="form" />
                    </div>
                </div>
            </div>
            <div class="ah-container" v-if="form.sno != null">
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">修改紀錄</div>
                    </div>
                    <div class="panel-body">
                        <center>
                            <div class="editMemoBlock" style="margin-top: 20px">
                                <el-form-item prop="mem" label="修改原因">
                                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" placeholder="敘述本次修改原因" v-model="form.mem" :maxlength="200" :show-word-limit="true">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </center>
                    </div>
                </div>
            </div>
            <div class="ah-container" style="display: flex; justify-content: space-between">
                <div>
                    <el-button v-if="isShowDeleteBtn() && !isQR()" @click="submitCancel" type="danger" plain icon="el-icon-delete">刪除專案</el-button>
                </div>
                <div>
                    <el-button @click="onBack()" icon="el-icon-close">取消</el-button>
                    <el-button
                        v-if="!isQR()"
                        type="primary"
                        icon="el-icon-check"
                        class="primary-action"
                        style="width: 150px"
                        :loading="isSubmitting"
                        :disabled="isSubmitting"
                        @click="onSubmit"
                    >送出</el-button>
                </div>
            </div>
        </el-form>
        <EditProjectTypeDialog :visible="editProjectTypeDialog.visible" @close="handleEditProjectTypeDialogClose" />
        <InvoiceDetailDialog @close="handleInvoiceDetailDialogClose" :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import EditProjectTypeDialog from '@/components/dashboard/ProjectType/EditDialog.vue';
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import ProjectDetailContractTab from '@/components/dashboard/Project/ProjectDetailContractTab.vue';

export default {
    name: 'ProjectEditPage',
    components: {
        EditProjectTypeDialog,
        InvoiceStatusLabel,
        InvoiceDetailDialog,
        ProjectDetailContractTab,
    },
    data() {
        // 自訂驗證 - 預計結束日期
        const validateEdt = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請選擇預計結案日'));
            } else if (value < this.form.sdt) {
                callback(new Error('需大於專案起始日'));
            } else {
                callback();
            }
        };

        // 自訂驗證 - 專案總價大於0
        const validateAmt = (rule, value, callback) => {
            if (value < 0) {
                callback(new Error('不可為負數'));
            } else {
                callback();
            }
        };

        return {
            isLoading: false,
            isSubmitting: false,
            isShowAutoInstAmtButton: true,
            installmentsErrorMsg: '',
            currStep: 1,
            pmList: [],
            paList: [],
            staffOptions: [],
            staffsToAdd: [],
            form: {
                sno: null, // 編號
                nam: '', // 專案名稱
                customnumber: '',
                typ: 'PJ', // PJ=專案 或 SP=特定費用項目
                pjcaT_SNO: null, // 專案類型
                vdR_SNO: null, // 客戶代碼
                sdt: '', // 專案開始日
                edt: '', // 預計結案日
                amt: 0, // 總金額
                cny: 'TWD', // 幣別,
                cnl: 0, // 0=啟用, 1=取消
                note: '', // 調整原因
                stF_SNO: null,
                projectAuditor: null,
                installments: [], // 款項
                contractFiles: [],
                qtA_FLG: 0, // 報價單
                // ctT_FLG: 0, // 合約
                // ctT_SDT: null, // 合約起日
                // ctT_EDT: null, // 合約訖日
                amT_PREOUT: 0, // 預算
                public_PAYOUT: false,
                public_INVOICE: false,
                isServiceFeeStatement: false,
                // filE_QUOTATION: null,
                // filE_CONTRACT: null,
                mem: null,
                stG_STS: 0,
                isProjectDetailsVisible: true,
                isProjectBudgetVisible: true,
                projectUsePermision: 1, // 1=公開、2=不公開、3=限指定成員使用
                projectEmployeePermissions: [],
            },
            deleteInstallmentsCount: 0,
            projectDocType: 1,
            vendorList: [],
            projectTypeOptions: [],
            grossMargin: '---',
            rules: {
                pjcaT_SNO: [
                    {
                        required: true,
                        message: '請選擇專案類型',
                        trigger: 'change',
                    },
                ],
                nam: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value || value.trim() === '') {
                                callback(new Error('請輸入專案名稱'));
                            } else if (value.length < 2) {
                                callback(new Error('專案名稱至少需2個字元'));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
                vdR_SNO: [{ required: true, message: '請選擇客戶', trigger: 'blur' }],
                sdt: [
                    {
                        required: true,
                        message: '請選擇專案開始日',
                        trigger: 'blur',
                    },
                ],
                edt: [
                    {
                        required: true,
                        message: '請選擇預計結案日',
                        trigger: 'blur',
                    },
                    { validator: validateEdt, trigger: 'blur' },
                ],
                amt: [
                    {
                        required: true,
                        message: '請輸入專案總價',
                        trigger: 'blur',
                    },
                    { validator: validateAmt, trigger: 'blur' },
                ],
                amT_PREOUT: [
                    {
                        required: true,
                        message: '請輸入支出預算',
                        trigger: 'blur',
                    },
                ],
                mem: [
                    {
                        required: true,
                        message: '請填寫修改原因',
                        trigger: 'blur',
                    },
                ],
            },
            editProjectTypeDialog: {
                visible: false,
            },
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            isAuditFlowSettingEnable: {
                isEnable: false,
                settings: [],
            },
            // 專案成員的預先設定資料（前端用呈現用）
            projectMembers: {
                PPMS: [], // 總管理(多人)
                PM: {
                    // PM（單人）
                    id: 'project-member-pm',
                    employeeSno: null,
                    employeeName: '',
                    paymentRequest: true,
                    paymentBudgetChart: true,
                    invoice: true,
                    laborForm: true,
                    viewProject: true,
                    uploadDocument: true,
                    role: 'PM',
                },
                PA: {
                    // PA（單人）
                    id: 'project-member-pa',
                    employeeSno: null,
                    employeeName: '',
                    paymentRequest: true,
                    paymentBudgetChart: true,
                    invoice: true,
                    laborForm: true,
                    viewProject: true,
                    uploadDocument: true,
                    role: 'PA',
                },
                STAFFS: [], // 指定人(多人)
                OTHER: {
                    // 其他所有人
                    id: 'project-member-others',
                    employeeSno: null,
                    employeeName: '其他所有人',
                    paymentRequest: false,
                    paymentBudgetChart: false,
                    invoice: false,
                    laborForm: false,
                    viewProject: false,
                    uploadDocument: false,
                    role: 'OTHER',
                },
            },
        };
    },
    computed: {
        isProjectAuditorAuditNeed() {
            if (!this.isAuditFlowSettingEnable.isEnable) return false;

            let PROJECT_AUDITOR_FOUND = _.chain(this.isAuditFlowSettingEnable.settings).flatMap('steps').find(['menU_UNT', '專案經辦人']).value();

            if (!PROJECT_AUDITOR_FOUND) {
                PROJECT_AUDITOR_FOUND = _.chain(this.isAuditFlowSettingEnable.settings).flatMap('steps').find(['menU_UNT', '專案審核人']).value();
            }

            return !!PROJECT_AUDITOR_FOUND;
        },
        userSno() {
            return this.$store.getters['account/userSno'];
        },
        amtInTwd() {
            return Math.round(this.form.amt * this.getCnyRat(this.form.cny));
        },
        currencyList() {
            return this.$store.getters['cny/cnyOptions'];
        },
        isCreator() {
            return this.form.stF_SNO === this.userSno;
        },
        enableCancel() {
            if (this.form.sno) {
                if (this.form.installments.length === 0 && this.form.payouts.length === 0) {
                    return true;
                }
            }
            return false;
        },
        // 分期總額（排除發票已作廢的分期）
        installmentsTotal() {
            let sum = 0;
            if (this.availableInstallments) {
                this.availableInstallments.forEach((item) => {
                    if (!item.foO_DIS_CNL) {
                        // 未作廢才計入
                        sum += Number(item.amt);
                    }
                });
            }
            return sum;
        },

        // 有效的分期（排除已刪除、作廢的發票）
        availableInstallments() {
            return this.form.installments.filter((item) => item.Delete !== true && item.status !== 5);
        },

        // 可否編輯專案幣別
        isCnyDisabled() {
            if (!this.form.sno) return false;

            // 取得已申請發票的分期，有就不可改幣別
            const invoicedInst = this.form.installments.filter((item) => item.invoiceIOO !== null);
            if (invoicedInst.length > 0) {
                return true;
            }

            // 取得專案請款，已有外幣請款就不可改幣別，只有台幣請款時可以改幣別
            if (this.form.payouts.find((p) => p.cny !== 'TWD')) {
                return true;
            }

            return false;
        },

        installmentsDiscountTotal() {
            let sum = 0;
            const LIST = _.chain(this.form.installments).filter(['foO_DIS_CNL', false]).sortedUniqBy(this.form.installments, 'foO_DIS_AMT').value();
            console.log(LIST);
            LIST.forEach((item) => {
                sum += item.foO_DIS_AMT;
            });

            return sum;
        },
        // 驗證-分期總價
        validateInstallments() {
            return Math.round(this.installmentsTotal * 10000) / 10000 === this.form.amt;
        },
        // 已選取的專案經辦人
        selectedPA() {
            if (!this.paList) return null;
            if (!this.form.projectAuditor) return null;
            return this.paList.find((x) => x.sno === this.form.projectAuditor);
        },
        companyInfo() {
            return this.$store.getters['menu/companyInfo'];
        },
        // 合併後的專案成員（用於給 table 呈現資料）
        combinedProjectMembers() {
            const IS_PM_EXIST = this.projectMembers.PM.employeeSno;
            const IS_PA_EXIST = this.projectMembers.PA.employeeSno;
            const IS_PA_PM_SAME_USER = this.projectMembers.PA.employeeSno === this.projectMembers.PM.employeeSno;

            return [
                ...this.projectMembers.PPMS,
                ...(IS_PM_EXIST ? [this.projectMembers.PM] : []), // PM 可無
                ...(IS_PA_EXIST && !IS_PA_PM_SAME_USER ? [this.projectMembers.PA] : []), // PA 可無
                ...this.projectMembers.STAFFS,
                this.projectMembers.OTHER,
            ];
        },
        filteredStaffOptions() {
            return this.staffOptions.filter((staff) => !this.combinedProjectMembers.some((member) => member.employeeSno === staff.sno));
        },
    },
    async mounted() {
        try {
            this.isLoading = true;
            await this.fetchAuditFlow();
            this.fetchProjectTypeOptions();

            // 網址中含有序號，進入編輯模式，取得資料並載入
            const { sno } = this.$route.params;
            if (sno) await this.fetchExistData(sno);
            // 新增模式
            else {
                // 檢查網址是否帶有 copyfrom 參數，有的話從該專案複製資料
                const sourceSno = this.$route.query.copyfrom;
                if (sourceSno) {
                    // 複製欄位資料
                    await this.copyFromSno(sourceSno);
                } else {
                    this.addInstallment();
                    this.form.stF_SNO = this.userSno;
                }
            }

            // 載入客戶清單
            await this.updateVendorList(!this.companyInfo.displayClient);

            // 載入PM清單
            await this.fetchPmList();

            // 載入員工清單
            this.staffOptions = await this.fetchStaffOptions();

            // 專案成員填入PM, PA人員名字
            this.applyFixedProjectMembersData('PM', this.form.stF_SNO);
            this.applyFixedProjectMembersData('PA', this.form.projectAuditor);

            // 填入專案總管理設定
            const c04StaffsResp = await this.$api({
                url: 'ProjectManagementPage/getC04Staffs',
                method: 'GET',
            });

            this.projectMembers.PPMS = c04StaffsResp.data.items.map((pm) => ({
                id: `project-member-ppm-${pm.sno}`,
                employeeSno: pm.sno,
                employeeName: `${pm.nam} (專案總管理)`,
                paymentRequest: true,
                paymentBudgetChart: true,
                invoice: true,
                laborForm: true,
                viewProject: true,
                uploadDocument: true,
                role: 'PPM',
            }));

            // 填入PA設定
            this.projectMembers.PA.paymentRequest = this.form.enablePAPaymentRequest && !!this.projectMembers.PA.hasA01;
            this.projectMembers.PA.paymentBudgetChart = this.form.enablePAPaymentBudgetChart && !!this.projectMembers.PA.hasA01;
            this.projectMembers.PA.invoice = this.form.enablePAInvoice && !!this.projectMembers.PA.hasB01;
            this.projectMembers.PA.laborForm = this.form.enablePALaborForm && !!this.projectMembers.PA.hasH01;
            this.projectMembers.PA.viewProject = this.form.enablePAViewProject;
            this.projectMembers.PA.uploadDocument = this.form.enablePAUploadDocument;

            // 填入現有成員
            this.form.projectEmployeePermissions.forEach((member) => {
                this.addProjectMemberStaff(member.employeeSno, {
                    id: member.id,
                    paymentRequest: member.paymentRequest,
                    paymentBudgetChart: member.paymentBudgetChart,
                    invoice: member.invoice,
                    laborForm: member.laborForm,
                    viewProject: member.viewProject,
                    uploadDocument: member.uploadDocument,
                });
            });
            // 填入其他所有人設定
            this.projectMembers.OTHER.paymentRequest = this.form.enableOthersPaymentRequest;
            this.projectMembers.OTHER.paymentBudgetChart = this.form.enableOthersPaymentBudgetChart;
            this.projectMembers.OTHER.invoice = this.form.enableOthersInvoice;
            this.projectMembers.OTHER.laborForm = this.form.enableOthersLaborForm;

            // 使用 cache 資料（委外新增後返回）
            if (this.$route.query.cache === 1) {
                this.loadFromCache();
            }

            if (this.$route.query.vendorsno != null) {
                if (this.companyInfo.displayClient) {
                    this.form.vdR_SNO = parseInt(this.$route.query.vendorsno, 10);
                    this.updateVendorList();
                }
            }

            this.updateShowAutoInstAmtButton();
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    },
    watch: {
        'form.amt': function () {
            this.updateGrossMargin();
        },
        'form.amT_PREOUT': function () {
            this.updateGrossMargin();
        },
    },
    methods: {
        isInstallmentEditDisabled(row) {
            if (!this.form.sno) return false;
            if (!row.invoiceIOO) return false;
            if (row.status === 4) return false;
            return true;
        },
        saveToCache() {
            console.log('project cached');
            localStorage.setItem('project-cashe', JSON.stringify(this.form));
        },

        loadFromCache() {
            const rowdata = localStorage.getItem('project-cashe');
            if (rowdata) {
                this.applyFormData(JSON.parse(rowdata));
            }
            if (!rowdata) {
                console.log('no cached data found.');
            }
        },

        applyFormData(targetForm) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of Object.entries(targetForm)) {
                this.form[key] = value;
            }
        },
        onAddVendoerBtnClick() {
            this.saveToCache();
            this.$router.push({
                name: 'vendor-add',
                query: {
                    from: 'project-add',
                },
            });
        },
        handleInvoiceDetailDialogClose(refresh) {
            this.$emit('detailClose', refresh);
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
        handleInvoiceIOOClick(sno) {
            this.invoiceDetailDialog.visible = true;
            this.invoiceDetailDialog.sno = sno;
        },
        updateGrossMargin() {
            let gm = null;
            const amt = this.form.amt * this.getCnyRat(this.form.cny);
            const budget = this.form.amT_PREOUT;

            if (amt) {
                if (!budget) gm = 100;
                else {
                    gm = Math.round(((amt - this.installmentsDiscountTotal - budget) / (amt - this.installmentsDiscountTotal)) * 100);
                }
            }

            if (gm === null) this.grossMargin = '---';
            else this.grossMargin = `${gm}%`;
        },

        // 增加分期按鈕按下
        handleAddInstallmentBtnClick() {
            this.addInstallment();
        },

        handleRestoreInstallmentBtnClick() {
            for (let i = 0; i < this.form.installments.length; i += 1) {
                if (this.form.installments[i].Delete === true) {
                    this.form.installments[i].Delete = false;
                    this.form.installments[i].amt = this.form.installments[i].amt_bak;
                }
            }
            this.updateDeleteInstallmentsCount();
            // this.updateInstallmentsStgNo()
        },

        handleAmtChanged() {
            if (!this.form.sno && this.form.installments.length === 1) {
                this.form.installments[0].amt = this.form.amt;
            }
        },

        handleEditProjectTypeDialogClose(resp) {
            this.editProjectTypeDialog.visible = false;

            if (resp.refresh) this.fetchProjectTypeOptions();

            if (resp.newSno) {
                this.form.pjcaT_SNO = resp.newSno;
            }
        },

        getCnyRat(cny) {
            const cnyOption = this.currencyList.find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        async fetchExistData(sno) {
            const resp = await this.$api({
                url: `ProjectManagementPage/GetProjectDetail?Sno=${sno}`,
                method: 'GET',
            });
            this.form = resp.data.item;
            this.form.mem = null;

            for (let i = 0; i < this.form.installments.length; i += 1) {
                this.form.installments[i].Delete = false;
                this.form.installments[i].key = Date.now() + i;
            }
            console.log('Project', this.form);
        },

        fetchProjectTypeOptions() {
            this.$api({
                url: 'ProjectManagementPage/GetProjectCategoryOptions',
                method: 'GET',
            }).then((resp) => {
                this.projectTypeOptions = resp.data.options;
            });
        },

        // 增加分期項目
        addInstallment() {
            this.form.installments.push({
                key: Date.now(),
                sno: null,
                mno: 0,
                fsno: this.form.sno ? this.form.sno : 0,
                poo: this.form.sno ? this.form.poo : '',
                stG_NO: (this.availableInstallments.length + 1).toString(),
                sts: 0,
                amt: 0,
                cny: this.form.cny,
                Delete: false,
                invoiceNo: null,
                invoiceIOO: null,
            });
            this.updateShowAutoInstAmtButton();
        },

        averageInstallmentsAmt() {
            if (this.form.installments.length > 0) {
                // 計算出已申請發票的分期總額（不含作廢）
                let invoicedTotal = 0;
                const avaInsIndexList = [];
                this.form.installments.forEach((ins, i) => {
                    if (!ins.Delete) {
                        // 已開發票、未作廢總額
                        if (ins.invoiceIOO !== null && !ins.foO_DIS_CNL) {
                            invoicedTotal += ins.amt;
                        }
                        // 未開發票分期數
                        if (ins.invoiceIOO === null) {
                            avaInsIndexList.push(i);
                        }
                    }
                });

                // 計算剩餘可分配總額
                const availableTotal = this.form.amt - invoicedTotal;
                if (availableTotal < 0) {
                    this.$message({ type: 'warning', message: '專案總價低於已開立分期總計，請調整專案總價' });
                    this.$refs.amtInput.focus();
                    return;
                }
                if (availableTotal === 0) {
                    this.$message({ type: 'warning', message: '無可分配的專案金額，請調整專案總價' });
                    this.$refs.amtInput.focus();
                    return;
                }

                // 計算出可分配分期平均金額
                let availableInstAmt = Math.round((availableTotal / avaInsIndexList.length) * 10000) / 10000;

                // 新台幣去除小數點
                if (this.form.cny === 'TWD') {
                    availableInstAmt = Math.floor(availableInstAmt);
                }
                console.log('invoicedTotal', invoicedTotal);
                console.log('avaInsIndexList', avaInsIndexList);
                console.log('availableTotal', availableTotal);
                console.log('availableInstAmt', availableInstAmt);

                // 逐一填入可分配分期
                for (let i = 0; i < avaInsIndexList.length; i += 1) {
                    const idx = avaInsIndexList[i];
                    this.form.installments[idx].amt = availableInstAmt;
                }

                // 最後一個特別處理，避免有餘數問題
                const lastIdx = avaInsIndexList[avaInsIndexList.length - 1];
                this.form.installments[lastIdx].amt = this.form.amt - invoicedTotal - availableInstAmt * (avaInsIndexList.length - 1);
            }
        },

        // 移除分期項目
        removeInstallment(item) {
            // 新增模式（直接移除）
            if (!this.form.sno) {
                const index = this.form.installments.indexOf(item);
                if (index !== -1) {
                    this.form.installments.splice(index, 1);
                }
            } else {
                // 編輯模式（加上 Delete = true）
                item.Delete = true;
                item.amt_bak = item.amt;
                item.amt = 0;
            }

            this.updateDeleteInstallmentsCount();
            this.updateShowAutoInstAmtButton();
        },

        updateDeleteInstallmentsCount() {
            let n = 0;
            for (let i = 0; i < this.form.installments.length; i += 1) {
                if (this.form.installments[i].Delete) {
                    n += 1;
                }
            }
            this.deleteInstallmentsCount = n;
        },

        // 自動分配分期項目編號
        updateInstallmentsStgNo() {
            let n = 1;
            for (let i = 0; i < this.form.installments.length; i += 1) {
                if (this.form.installments[i].Delete === false) {
                    this.form.installments[i].stG_NO = n.toString();
                    n += 1;
                }
            }
        },

        // 計算分期百分比
        getInstallmentItemPercent(installmentAmt) {
            const precent = Math.round((installmentAmt / this.form.amt) * 100);
            if (Number.isFinite(precent)) return `${precent}%`;
            return '--';
        },

        // 將分期幣別都設為與專案一樣
        normalizeInstallmentsCny() {
            for (let i = 0; i < this.form.installments.length; i += 1) {
                if (this.form.installments[i]) {
                    this.form.installments[i].cny = this.form.cny;
                }
            }
        },

        // 送出按下後
        async onSubmit() {
            // 驗證不可無分期
            if (this.form.installments.length <= 0) {
                await this.$confirm('至少需新增一個分期', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                return;
            }

            // 此專案總金額 1,000 元，與分期金額加總 1,500 元不相符，是否自動更新專案總額為 1,500 元？
            if (this.installmentsTotal !== this.form.amt) {
                await this.$confirm(`此專案總金額 ${this.form.amt} 元，與分期金額加總 ${this.installmentsTotal} 元不相符，是否自動更新專案總額為 ${this.installmentsTotal} 元？`, {
                    confirmButtonText: '是',
                    cancelButtonText: '取消',
                });

                this.form.amt = this.installmentsTotal;
                this.$refs.amtInput.focus();
                return;
            }

            // 表單驗證
            this.$refs.mainForm.validate(async (valid) => {
                if (valid) {
                    // 其他驗證
                    if (this.validateInstallments) {
                        this.normalizeInstallmentsCny();

                        // !!! 成員與權限設定: projectMembers 重新組合為 API 格式
                        // PA
                        this.form.enablePAPaymentRequest = this.projectMembers.PA.paymentRequest;
                        this.form.enablePAPaymentBudgetChart = this.projectMembers.PA.paymentBudgetChart;
                        this.form.enablePAInvoice = this.projectMembers.PA.invoice;
                        this.form.enablePALaborForm = this.projectMembers.PA.laborForm;
                        this.form.enablePAViewProject = this.projectMembers.PA.viewProject;
                        this.form.enablePAUploadDocument = this.projectMembers.PA.uploadDocument;

                        // 其他所有人
                        this.form.enableOthersPaymentRequest = this.projectMembers.OTHER.paymentRequest;
                        this.form.enableOthersPaymentBudgetChart = this.projectMembers.OTHER.paymentBudgetChart;
                        this.form.enableOthersInvoice = this.projectMembers.OTHER.invoice;
                        this.form.enableOthersLaborForm = this.projectMembers.OTHER.laborForm;

                        // 指定成員
                        this.form.projectEmployeePermissions = this.projectMembers.STAFFS;

                        console.log(this.form);
                        if (this.form.amt === 0) {
                            await this.$confirm('確定要新增零元的專案嗎？', {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }
                        // 送出表單
                        const resp = await this.$api({
                            url: 'ProjectManagementPage/UpsertProjectDetail',
                            data: this.form,
                            method: 'POST',
                        });

                        this.onBack(resp.data.sno);
                    } else {
                        console.log('error12');
                    }
                } else {
                    this.scrollViewToError();
                }
            });
        },

        submitCancel() {
            // 送出表單
            this.form.cnl = 1;

            this.$confirm('確定要刪除該專案？', {
                confirmButtonText: '確定刪除',
                cancelButtonText: '取消',
            }).then(() => {
                this.$api({
                    url: 'ProjectManagementPage/DeleteProjectDetail',
                    data: { sno: this.form.sno },
                    method: 'DELETE',
                }).then(() => {
                    this.$router.push({ name: 'project' });
                });
            });
        },

        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        // 回到專案清單頁面
        onBack(projectsno) {
            if (this.$route.query.from) {
                this.$router.push({
                    name: this.$route.query.from,
                    query: { cache: 1, projectsno },
                });
            } else this.$router.push({ name: 'project' });
        },

        // 載入客戶清單
        async updateVendorList(init, query) {
            const resp = await this.$api({
                url: 'ProjectManagementPage/GetVendorList',
                method: 'GET',
                params: { keyword: query },
            });

            if (init) this.vendorList = resp.data.options.filter((o) => o.sno === this.form.vdR_SNO);
            else this.vendorList = resp.data.options;

            // 若目前已選客戶不在清單內（例如複製專案帶入的客戶未包含在預設/關鍵字查詢結果中），
            // 直接依 sno 補查該客戶資料，避免下拉選單只顯示 sno 數字
            if (this.form.vdR_SNO != null && !this.vendorList.some((o) => o.sno === this.form.vdR_SNO)) {
                const vendorResp = await this.$api({
                    url: 'VendorManagementPage/GetVendorInfo',
                    method: 'GET',
                    params: { SNO: this.form.vdR_SNO },
                });
                if (vendorResp.data.item) this.vendorList.push(vendorResp.data.item);
            }
        },

        vendorRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.updateVendorList(false, query);
        },

        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },

        async fetchPmList() {
            const resp = await this.$api({
                url: '/ProjectManagementPage/GetPMList',
                method: 'GET',
            });
            this.pmList = _.chain(resp.data.items)
                .filter((o) => (this.isAhooAgent ? true : o.nam !== 'Ahoo專員'))
                .filter((o) => o.pm || o.sno === this.form.stF_SNO)
                .filter((o) => !!o.active || o.sno === this.form.stF_SNO)
                .value();
            this.paList = _.chain(resp.data.items)
                .filter((o) => (this.isAhooAgent ? true : o.nam !== 'Ahoo專員'))
                .filter((o) => !!o.active)
                .value();
        },

        isShowDeleteBtn() {
            // 是專案PM & 分期未開
            if (this.form.payouts?.length) return false;

            if (this.form.sno != null && (this.isCreator || this.isAuth('C04'))) {
                const submitedInst = this.form.installments.filter((item) => !item.Delete && item.invoiceIOO != null);
                if (submitedInst.length === 0) return true;
            }
            return false;
        },
        onChangeProjectStatus(val) {
            if (val) this.form.mem = '專案結案';
        },
        async fetchAuditFlow() {
            const resp = await this.$api({
                url: '/Tool/GetAuditFlowTemplates',
                method: 'GET',
            });

            this.isAuditFlowSettingEnable = resp.data.projectAuditFlowSetting;
        },
        getInsAmtInputTooltipText(ins) {
            if (ins.foO_DIS_CNL) {
                return '該分期發票已作廢，此分期金額不計入專案總價。';
            }
            return '分期在申請發票後，無法修改，需退件或撤銷後再重新開立。';
        },
        updateShowAutoInstAmtButton() {
            if (this.form.installments.find((inst) => !inst.Delete && inst.invoiceIOO === null)) {
                this.isShowAutoInstAmtButton = true;
            } else {
                this.isShowAutoInstAmtButton = false;
            }
        },
        onNamInputKeydown(event) {
            if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
                return false;
            }
            return true;
        },
        onCnyChange() {
            if (this.form.cny === 'TWD') {
                // 專案金額四捨五入
                this.form.amt = Math.round(this.form.amt);
                // 專案分期金額全部四捨五入
                this.form.installments.forEach((item) => {
                    // eslint-disable-next-line no-param-reassign
                    item.amt = Math.round(item.amt);
                });
            }
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            // 或者檢查 e.isComposing (現代瀏覽器支援)
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
        async copyFromSno(sno) {
            try {
                // 載入來源請款單資料
                const resp = await this.$api_silent({
                    url: `/ProjectManagementPage/GetProjectDetail?Sno=${sno}`,
                    method: 'GET',
                });

                const source = resp.data.item;

                if (source) {
                    // 複製欄位
                    const copyProps = [
                        // 'sno',
                        'nam',
                        'customnumber',
                        'typ',
                        'pjcaT_SNO',
                        'vdR_SNO',
                        'sdt',
                        'edt',
                        'amt',
                        'cny',
                        'cnl',
                        'note',
                        'stF_SNO',
                        'projectAuditor',
                        'qtA_FLG',
                        'amT_PREOUT',
                        'public_PAYOUT',
                        'public_INVOICE',
                        'isServiceFeeStatement',
                        'mem',
                        'stG_STS',
                        'isProjectDetailsVisible',
                        'isProjectBudgetVisible',
                    ];

                    // 複製欄位資料
                    _.forEach(copyProps, (key) => {
                        this.form[key] = source[key];
                    });

                    // 複製檢附文件
                    this.form.contractFiles = source.contractFiles.map((file) => ({
                        ...file,
                        sno: null,
                        projectSno: null,
                        updateUser: this.$store.getters['account/userName'],
                        updateDate: Number(moment().format('x')),
                    }));

                    // 複製分期
                    this.form.installments = source.installments.map((installment, index) => ({
                        key: Date.now() + index,
                        sno: null,
                        mno: 0,
                        fsno: 0,
                        poo: '',
                        stG_NO: (index + 1).toString(),
                        sts: 0,
                        amt: installment.amt,
                        cny: installment.cny,
                        Delete: false,
                        invoiceNo: null,
                        invoiceIOO: null,
                    }));
                }
            } catch (e) {
                let errorMsg;

                if (e.response.data === '資料不存在') {
                    errorMsg = '來源專案不存在，無法複製';
                } else {
                    errorMsg = '載入來源專案資料失敗，無法複製';
                }

                this.$message({
                    showClose: true,
                    message: errorMsg,
                    type: 'error',
                });
                this.addInstallment();
                this.form.stF_SNO = this.userSno;
            }
        },
        async fetchStaffOptions() {
            const resp = await this.$api({
                url: '/ProjectManagementPage/GetManagerOptions',
                params: {
                    PageSize: 999,
                    PageNum: 1,
                    ONF: 1,
                },
                method: 'GET',
            });
            return resp.data.options
                .reverse()
                .filter(
                    (x) => !!x.grP_NO
                        && x.grP_NO !== 'OT1'
                        && x.grP_NO !== 'OT2'
                        && x.grP_NO !== 'OT3'
                        && x.grP_NO !== 'OT4'
                        && x.grP_NO !== 'OT5'
                        && x.grP_NO !== 'ADM'
                        && x.grP_NO !== 'SA'
                        && x.grP_NO !== 'INI',
                );
        },

        onPmChange() {
            this.applyFixedProjectMembersData('PM', this.form.stF_SNO);
        },

        onPaChange() {
            this.applyFixedProjectMembersData('PA', this.form.projectAuditor);
            this.applyFixedProjectMembersData('PM', this.form.stF_SNO);
        },

        // 填入固定專案成員資料
        applyFixedProjectMembersData(role, sno) {
            // sno = NULL 就清除
            if (this.projectMembers[role] && !sno) {
                this.projectMembers[role].employeeSno = null;
                this.projectMembers[role].employeeName = '';
                return;
            }

            // 取得人員資料
            const staffToAdd = this.staffOptions.find((x) => x.sno === sno);
            if (!staffToAdd) return;

            // apply 資料
            const member = this.projectMembers[role];
            if (member) {
                let roleSuffix = '';
                if (role === 'PM') roleSuffix = this.form.stF_SNO === this.form.projectAuditor ? '專案經理(PM) / 專案經辦人' : '專案經理(PM)';
                if (role === 'PA') roleSuffix = '專案經辦人';

                member.employeeSno = staffToAdd.sno;
                member.employeeName = `${staffToAdd.nam} (${roleSuffix})`;
                member.hasA01 = staffToAdd.hasA01;
                member.hasB01 = staffToAdd.hasB01;
                member.hasH01 = staffToAdd.hasH01;

                // 依據各自的系統權限重置專案選項，有權限就全勾，沒權限則維持不勾
                member.paymentRequest = !!staffToAdd.hasA01;
                member.paymentBudgetChart = !!staffToAdd.hasA01;
                member.invoice = !!staffToAdd.hasB01;
                member.laborForm = !!staffToAdd.hasH01;
                member.viewProject = true;
                member.uploadDocument = true;
            }
        },

        // 確認是否已在專案成員清單中
        isProjectMember(sno) {
            return !this.combinedProjectMembers.find((x) => x.employeeSno === sno);
        },

        // 成員新增按鈕按下
        onAddMemberBtnClick() {
            this.staffsToAdd.forEach((sno) => {
                this.addProjectMemberStaff(sno);
            });
            this.staffsToAdd = [];
        },

        // 新增專案成員
        addProjectMemberStaff(sno, permissions) {
            // 取得人員資料
            const staffToAdd = this.staffOptions.find((x) => x.sno === sno);
            if (!staffToAdd) return;

            // 不能重複加入
            const exists = this.projectMembers.STAFFS.find((x) => x.employeeSno === sno);
            if (exists) return;

            // 資料
            const member = {
                id: permissions?.id || null,
                employeeSno: staffToAdd.sno,
                employeeName: staffToAdd.nam,
                paymentRequest: (permissions?.paymentRequest || false) && !!staffToAdd.hasA01,
                paymentBudgetChart: (permissions?.paymentBudgetChart || false) && !!staffToAdd.hasA01,
                invoice: (permissions?.invoice || false) && !!staffToAdd.hasB01,
                laborForm: (permissions?.laborForm || false) && !!staffToAdd.hasH01,
                viewProject: permissions?.viewProject || false,
                uploadDocument: permissions?.uploadDocument || false,
                role: 'STAFF',
                hasA01: staffToAdd.hasA01,
                hasA02: staffToAdd.hasA02,
                hasA03: staffToAdd.hasA03,
                hasB01: staffToAdd.hasB01,
                hasB02: staffToAdd.hasB02,
                hasB03: staffToAdd.hasB03,
                hasH01: staffToAdd.hasH01,
                hasD22: staffToAdd.hasD22,
                hasE01: staffToAdd.hasE01,
                hasE02: staffToAdd.hasE02,
                hasE03: staffToAdd.hasE03,
            };

            // 加入列表
            this.projectMembers.STAFFS.push(member);
        },

        // 移除專案成員
        removeProjectMemberStaff(sno) {
            this.projectMembers.STAFFS = this.projectMembers.STAFFS.filter((x) => x.employeeSno !== sno);
        },

        // 專案成員勾選設定是否可用
        getEmployeeSettingEnable(role) {
            if (!this.isPayed('C07')) {
                return role !== 'OTHER' && role !== 'PA';
            }
            return role === 'PPM' || role === 'PM' || role === 'PTM';
        },

        // 判斷是否為「無對應權限」的狀況
        isNoPermission(row, permKey) {
            // 指定人 role 在資料面是寫 'STAFF'
            if (['PM', 'PA', 'STAFF'].includes(row.role)) {
                return !row[permKey];
            }
            return false;
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    margin-bottom: 40px;
    border-radius: 15px;
    margin-bottom: 20px;
}
.contract {
    display: flex;
    justify-content: space-between;
    > * {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .date {
        font-size: 9pt;
        color: #aaa;
    }
}
</style>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.project-edit-page {
    .installments-table-area {
        margin-bottom: 10px;
        margin-left: 0px;
        margin-right: 0px;

        @media (min-width: 1200px) {
            margin-left: 220px;
            margin-right: 50px;
        }
        @media (min-width: 1300px) {
            margin-right: 100px;
        }
    }

    .el-input.installment-no input {
        text-align: center;
        padding-left: 5px;
        padding-right: 5px;
    }
    .invoiceVoidLabel {
        display: inline-block;
        padding: 3px 8px;
        border-radius: 4px;
        margin-left: 10px;
        color: #ff0000;
        font-size: 9pt;
        white-space: nowrap;
        cursor: default;

        &:hover {
            background-color: #ffeded;
        }
    }
    .voidInsAmtInput {
        opacity: 0.4;
    }
    .error-msg {
        color: red;
        font-size: 9pt;
    }
    .inst-no-set {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .inst-invoice-set {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 260px;
    }
    .installmentsTotalInvalidAlert {
        color: red;
        font-size: 10pt;
        text-align: right;
        padding: 10px 12px;
        white-space: nowrap;
    }
    .total-area {
        margin-bottom: 40px;
        text-align: right;
        .total-table {
            width: 430px;
            margin: 0 0 0 auto;
            th {
                font-weight: normal;
                font-size: 11pt;
                text-align: left;
                padding: 12px;
                border-bottom: 1px solid #ebeef5;
            }
            td {
                font-weight: normal;
                font-size: 11pt;
                text-align: left;
                padding: 12px;
                border-bottom: 1px solid #ebeef5;
                text-align: right;

                .cny {
                    margin-left: 15px;
                }
            }
        }
    }
    .suffix-box {
        display: inline-block;
        line-height: 40px;
        height: 40px;
        font-size: 9pt;
        color: #888;
        background-color: #f4f4f4;
        padding: 0 15px;
        margin-left: 6px;
        border-radius: 5px;
        white-space: nowrap;
        cursor: default;
    }
    .project-auditor-settings {
        margin: 20px 0 20px 0;
        font-size: 10pt;
    }
    .project-auditor-view-warning {
        line-height: 150%;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        background-color: #fdf6ec;
        color: #e6a23c;
        padding: 11px 15px;
        font-size: 9pt;
        border-radius: 5px;
    }
    .staff-member-name.PPM,
    .staff-member-name.PM,
    .staff-member-name.PA,
    .staff-member-name.OTHER {
        opacity: 0.4;
        font-weight: 500;
    }
    .auth-check-item {
        display: flex;
        gap: 10px;
        cursor: default;
    }
}

.project-edit-page-project-auditor-option-view-hint {
    display: inline-block;
    width: 20px;
    font-size: 9pt;
}
</style>
